// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"65e4ba0b","308":"b200637e","386":"c808ea4d","453":"8ab44547","726":"d70df2d9","846":"f6949e8b","894":"5a74eb24","987":"8418e13b"}[chunkId] + ".chunk.js";
};